import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CoolerWelcomePage } from './cooler-welcome.page';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule,
    ],
    declarations: [CoolerWelcomePage]
})
export class CoolerWelcomePageModule { }

